import * as Yup from 'yup';
import { t } from 'ttag';

export const roleValidationSchema = Yup.object().shape({
  name: Yup.string().required(t`Required field.`),
  description: Yup.string(),
  users: Yup.array(),
});
